import React, { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginBanner, LoginLogo } from 'src/assets/images';

interface IProps {
  children: React.ReactNode;
  title?: string;
}

const AuthLayout: React.FC<IProps> = ({ children, title }) => {
  return (
    <div className="AuthCont grid grid-cols-12 gap-2 min-h-screen overflow-hidden">
      <div className="AuthCont--inner col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-5 max-h-screen overflow-scroll">
        <div className="px-10 py-10 flex flex-col justify-between min-h-screen  mx-auto max-w-[477px]">
          {title && <h1 className="text-4xl font-semibold mb-5">{title}</h1>}
          {children}
        </div>
      </div>
      <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-7 w-full sticky h-screen">
        <img src={LoginBanner} alt="" className="w-full h-full object-cover" />
        <div className="absolute top-0 left-0 w-full h-full bg-black  opacity-50 z-10"></div>
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center z-20">
          <img src={LoginLogo} alt="login-logo" className="object-cover" />
        </div>
      </div>
    </div>
  );
};

export default React.memo(AuthLayout);
